import ReelsetController from "../../../Elements/Reel/ReelsetController";

class MainReelsetController extends ReelsetController {}

export default MainReelsetController;
